import { render, staticRenderFns } from "./DeleteSmsTemplate.vue?vue&type=template&id=6647d74e&"
import script from "./DeleteSmsTemplate.vue?vue&type=script&lang=js&"
export * from "./DeleteSmsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports